@if (modalService.activeModal(); as modal) {
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/45 px-4 backdrop-blur-sm"
    (click)="modalService.close()">
    <div
      class="bg-white rounded-lg shadow-2xl w-full max-w-lg border border-maersk-border overflow-hidden"
      (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-maersk-border">
        <h3 class="text-lg font-semibold text-maersk-900">{{ modal.title }}</h3>
        <button
          class="ops-tool-btn"
          aria-label="Close modal"
          (click)="modalService.close()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="px-6 py-4">
        <ng-container *ngComponentOutlet="modal.component; inputs: { model: modal.model }" />
      </div>

      <!-- Footer -->
      <div class="flex justify-end gap-3 px-6 py-4 border-t border-maersk-border">
        <button
          class="ops-btn ops-btn-secondary"
          (click)="modalService.close()">
          Cancel
        </button>
        <button
          class="ops-btn ops-btn-primary"
          (click)="modalService.confirm()">
          OK
        </button>
      </div>
    </div>
  </div>
}
